module.exports = {"prices":{"location":"LHR","per_day":"16.12","per_week":"128.99","two_week":"174.75","off_airport":"109.95","on_airport":"128.99","meet_and_greet":"123.75","per_day_off_airport":"13.74","per_day_on_airport":"16.12","per_day_meet_and_greet":"15.47","startDate":"25-08-2025","endDate":"01-09-2025","dateUsed":"25-06-2025"}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/LHR.json
// module id = 141
// module chunks = 119